import { ControlState, StateSystem } from "../../../shared/systems/stateSystem";
import { GameClient } from "../gameClient";
import { GameState } from "../../../shared/game";
import { advanceTrainingLevel, getLadderRank, setLadderRank, setTrainingLevel } from "../userSettings";
import { recordGameResult } from "../userStats";
import { getGameModeName } from "../../../shared/replayStats";
import * as AchievementTracker from "../AchievementTracker";
import { endGame } from "../gameStats";

export class ClientEndGameState extends ControlState {
	isComplete = false; //gameclient sets this externally
	hasAdvanced = false;

	getName(): GameState {
		return "end"
	}

	constructor(private gameClient: GameClient) {
		super();
	}

	onEnter(controller: StateSystem): void {
		const player = this.gameClient.getPlayer();
		const hasWon = this.gameClient.hasWon(player);
		endGame(player?.currentFunds ?? 0);
		AchievementTracker.onEndGame(this.gameClient, hasWon);
		this.gameClient.playTimer.pause(); //resumed in endless

		//An endless game was counted when its regular rounds ended. Joined players don't start games, so they aren't counted
		if (!this.gameClient.endlessMode && !this.gameClient.isSpawnGame) {
			recordGameResult(getGameModeName(this.gameClient.players, this.gameClient.trainingLevel), hasWon);
		}
		if (hasWon) {
			this.hasAdvanced = advanceTrainingLevel(this.gameClient);
		}


		if (this.gameClient.isRankedGame) {
			const opponent = this.gameClient.players.find(p => p.id !== player?.id);
			if (opponent) {
				const rank = getLadderRank();
				if (hasWon) {
					setLadderRank(rank + 1);
				} else {
					setLadderRank(rank - 1);
				}
			}
		}

		this.gameClient.updateUI();
		this.gameClient.sendTelemetry();
	}

	onExit(controller: StateSystem): void {
	}

	update(delta: number): void {
	}
}
